// extracted by mini-css-extract-plugin
export default {"centerContent":"Thankyou_centerContent__fkkYm"};